import { render, staticRenderFns } from "./text-button.vue?vue&type=template&id=073fb930&scoped=true"
import script from "./text-button.vue?vue&type=script&lang=js"
export * from "./text-button.vue?vue&type=script&lang=js"
import style0 from "./text-button.vue?vue&type=style&index=0&id=073fb930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073fb930",
  null
  
)

export default component.exports